import type { AxiosInstance } from 'axios';

import { CONFIG } from 'src/global-config';

import msalClient from '../msal-instance';

export function addAxiosMsalTokenInterceptor(axios: AxiosInstance) {
  axios.interceptors.request.use(
    async (config) => {
      const activeAccount = msalClient.getActiveAccount();
      if (activeAccount) {
        const tokenResult = await msalClient.acquireTokenSilent({
          scopes: CONFIG.msal.scopes,
        });

        const token = tokenResult.accessToken;
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      }

      return config;
    },
    (error) => Promise.reject(error)
  );
}
